export interface Tag {
  tagId: number;
  tagName: string;
  displayName: string;
}

export const TAGS: Tag[] = [
  { tagId: 1, tagName: 'pre', displayName: 'PRE' },
  { tagId: 2, tagName: 'hot', displayName: 'HOT' },
  { tagId: 3, tagName: 'new', displayName: 'NEW' },
  { tagId: 4, tagName: 'sale', displayName: 'SALE' },
  { tagId: 5, tagName: 'sold out', displayName: 'SOLD OUT' },
];

export const getTagById = (tagId: number): Tag | undefined => {
  return TAGS.find((tag) => tag.tagId === tagId);
};

export const getTagByName = (tagName: string): Tag | undefined => {
  return TAGS.find((tag) => tag.tagName === tagName);
};
